import axios from "axios";
import {
  RESPONSE_REQUIREMENT_PER_CLIENT_LIST_REQUEST,
  RESPONSE_REQUIREMENT_PER_CLIENT_LIST_SUCCESS,
  RESPONSE_REQUIREMENT_PER_CLIENT_LIST_FAIL,
  RESPONSE_REQUIREMENT_SINGLE_REQUEST,
  RESPONSE_REQUIREMENT_SINGLE_SUCCESS,
  RESPONSE_REQUIREMENT_SINGLE_FAIL,
  CREATE_RESPONSE_REQUIREMENT_REQUEST,
  CREATE_RESPONSE_REQUIREMENT_SUCCESS,
  CREATE_RESPONSE_REQUIREMENT_FAIL,
  UPDATE_RESPONSE_REQUIREMENT_REQUEST,
  UPDATE_RESPONSE_REQUIREMENT_SUCCESS,
  UPDATE_RESPONSE_REQUIREMENT_FAIL,
  DELETE_RESPONSE_REQUIREMENT_REQUEST,
  DELETE_RESPONSE_REQUIREMENT_SUCCESS,
  DELETE_RESPONSE_REQUIREMENT_FAIL,
} from "constants/responseRequirementConstants";
import { REACT_APP_API_URL } from "constants/apiConstants";
// import { getProductList, getSingleProduct } from "actions/productActions";
import ResponseRequirementsService from "services/response-requirements-service";

export const getResponsePerClientRequirementsList =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: RESPONSE_REQUIREMENT_PER_CLIENT_LIST_REQUEST,
      });

      const res =
        await ResponseRequirementsService.getPerClientResponseRequirements();
      console.log(
        "🚀 ~ file: responseRequirementActions.js:30 ~ getResponsePerClientRequirementsList ~ res:",
        res
      );

      dispatch({
        type: RESPONSE_REQUIREMENT_PER_CLIENT_LIST_SUCCESS,
        payload: res.foundClientResponseRequirements,
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: responseRequirementActions.js:37 ~ getResponsePerClientRequirementsList ~ error:",
        error
      );
      dispatch({
        type: RESPONSE_REQUIREMENT_PER_CLIENT_LIST_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const getResponseRequirementsSingle =
  (responseRequirementId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: RESPONSE_REQUIREMENT_SINGLE_REQUEST,
      });

      const res =
        await ResponseRequirementsService.getSingleResponseRequirements(
          responseRequirementId
        );
      console.log("🚀 ~ file: responseRequirementActions.js:58 ~ res:", res);

      dispatch({
        type: RESPONSE_REQUIREMENT_SINGLE_SUCCESS,
        payload: res.foundResponseRequirement,
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: responseRequirementActions.js:65 ~ error:",
        error
      );
      dispatch({
        type: RESPONSE_REQUIREMENT_SINGLE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const createNewResponseRequirement =
  (responseRequirements) => async (dispatch, getState) => {
    console.log(
      "🚀 ~ file: responseRequirementActions.js:90 ~ responseRequirements:",
      responseRequirements
    );
    try {
      dispatch({
        type: CREATE_RESPONSE_REQUIREMENT_REQUEST,
      });

      const res = await ResponseRequirementsService.createResponseRequirements(
        responseRequirements
      );
      console.log("🚀 ~ file: responseRequirementActions.js:86 ~ res:", res);
      // dispatch(getProductList());
      // dispatch(getSingleProduct(responseRequirement.product));

      dispatch({
        type: CREATE_RESPONSE_REQUIREMENT_SUCCESS,
        payload: res.newResponseRequirement,
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: responseRequirementActions.js:95 ~ error:",
        error
      );
      dispatch({
        type: CREATE_RESPONSE_REQUIREMENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const responseRequirementUpdating =
  (responseRequirementId, responseRequirement) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_RESPONSE_REQUIREMENT_REQUEST,
      });

      const res = await ResponseRequirementsService.editResponseRequirements(
        responseRequirementId,
        responseRequirement
      );
      console.log("🚀 ~ file: responseRequirementActions.js:117 ~ res:", res);

      // dispatch(getProductList());
      // dispatch(getSingleProduct(responseRequirement.product));

      dispatch({
        type: UPDATE_RESPONSE_REQUIREMENT_SUCCESS,
        payload: res,
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: responseRequirementActions.js:127 ~ error:",
        error
      );
      dispatch({
        type: UPDATE_RESPONSE_REQUIREMENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const responseRequirementDeleting =
  (responseRequirementId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: DELETE_RESPONSE_REQUIREMENT_REQUEST,
      });

      const res = await axios.delete(
        `${REACT_APP_API_URL}/admin/services/${responseRequirementId}`
      );

      dispatch({
        type: DELETE_RESPONSE_REQUIREMENT_SUCCESS,
        payload: res,
      });
    } catch (error) {
      dispatch({
        type: DELETE_RESPONSE_REQUIREMENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };
